import { render, staticRenderFns } from "./BoardsView.vue?vue&type=template&id=60f02ff0&scoped=true&"
import script from "./BoardsView.vue?vue&type=script&lang=js&"
export * from "./BoardsView.vue?vue&type=script&lang=js&"
import style0 from "./BoardsView.vue?vue&type=style&index=0&id=60f02ff0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60f02ff0",
  null
  
)

export default component.exports